import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchContractManagementDetails } from '../../actions/additional_actions';
import { FieldLike } from './utils';
import { getDateValue } from '../../utils/date';

class ReadOnlyContractManagementDetails extends Component {
    // static PropTypes = {
    //     cmDetail: PropTypes.array.isRequired
    // }

    constructor(props) {
        super(props);
        this.state = {

            cmDetail: {
                id: -1,
                projectId: this.props.contract.projectId,
                cntrctId: this.props.contract.contractId,
                prjctdCnstrctnStrtDt: '',
                actSubstntlCmpltnDt: '',
                substntlInspcDt: '',
                prjctdSubstntlInspcDt: '',
                punchLst: '',
                grntStrtDt: '',
                grntEndDt: '',
                finalInspctnDt: '',
                finalCompltnDt: '',
                cntrctClsoutDt: '',
                createdBy: '',
                createdDt: '',
                isActive: false,
                modifiedBy: '',
                modifiedDt: '',
                comments: ''
            }
        }
    }

    UNSAFE_componentWillMount() {
        const { contract } = this.props;
        this.props.fetchContractManagementDetails(contract.projectId, contract.contractId);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.contract.contractId !== this.props.contract.contractId) {
            this.props.fetchContractManagementDetails(this.props.contract.projectId, this.props.contract.contractId);

        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.cmDetail !== nextProps.cmDetail)
            this.setState({ cmDetail: nextProps.cmDetail })
        if (this.props.contract.contractId !== nextProps.contract.contractId)
            this.setState({ contract: nextProps.contract })
    }

    render() {
        const { cmDetail } = this.props;

        return (
            <div>
                {cmDetail.length > 0 ?
                    <div className="row static-modal-fields">
                        {this.props.contract.contractType.includes('Force Account/') ?
                            <div className="col l4 m3 s6">
                                <FieldLike label="Contract Close Out" value={getDateValue(cmDetail[0].cntrctClsoutDt)} />
                            </div>
                            : null}

                        {this.props.contract.contractType.includes('Construction/') ?
                            <div>
                                {this.props.contract.divisionName === 'Infrastructure' ?
                                    <div>
                                        <div className="col l4 m3 s6">
                                            <FieldLike label="Substantial Inspection" value={getDateValue(cmDetail[0].substntlInspcDt)} />
                                        </div>
                                        <div className="col l4 m3 s6">
                                            <FieldLike label="Actual Substantial Completion" value={getDateValue(cmDetail[0].actSubstntlCmpltnDt)} />
                                        </div>
                                        <div className="col l4 m3 s6">
                                            <FieldLike label="Final Completion" value={getDateValue(cmDetail[0].finalCompltnDt)} />
                                        </div>
                                        <div className="col l4 m3 s6">
                                            <FieldLike label="Contract Close Out" value={getDateValue(cmDetail[0].cntrctClsoutDt)} />
                                        </div>
                                    </div>
                                    :
                                    <div>
                                        <div className="col l4 m3 s6">
                                            <FieldLike label="Projected Construction Start" value={getDateValue(cmDetail[0].prjctdCnstrctnStrtDt)} />
                                        </div>
                                        <div className="col l4 m3 s6">
                                            <FieldLike label="Actual Construction Start" value={getDateValue(cmDetail[0].actCnstrctnStrtDt)} />
                                        </div>
                                        <div className="col l4 m3 s6">
                                            <FieldLike label="Substantial Inspection" value={getDateValue(cmDetail[0].substntlInspcDt)} />
                                        </div>
                                        <div className="col l4 m3 s6">
                                            <FieldLike label="Projected Substantial Completion" value={getDateValue(cmDetail[0].prjctdSubstntlInspcDt)} />
                                        </div>
                                        <div className="col l4 m3 s6">
                                            <FieldLike label="Actual Substantial Completion" value={getDateValue(cmDetail[0].actSubstntlCmpltnDt)} />
                                        </div>
                                        <div className="col l4 m3 s6">
                                            <FieldLike label="Punch List" value={cmDetail[0].punchLst ? 'Yes' : 'No'} />
                                        </div>
                                        <div className="col l4 m3 s6">
                                            <FieldLike label="Guarantee Start" value={getDateValue(cmDetail[0].grntStrtDt)} />
                                        </div>
                                        <div className="col l4 m3 s6">
                                            <FieldLike label="Guarantee End" value={getDateValue(cmDetail[0].grntEndDt)} />
                                        </div>
                                        <div className="col l4 m3 s6">
                                            <FieldLike label="Final Inspection" value={getDateValue(cmDetail[0].finalInspctnDt)} />
                                        </div>
                                        <div className="col l4 m3 s6">
                                            <FieldLike label="Final Completion" value={getDateValue(cmDetail[0].finalCompltnDt)} />
                                        </div>
                                        <div className="col l4 m3 s6">
                                            <FieldLike label="Contract Close Out" value={getDateValue(cmDetail[0].cntrctClsoutDt)} />
                                        </div>
                                    </div>
                                }
                            </div>
                            : null}

                        {(!this.props.contract.contractType.includes('Construction/') && !this.props.contract.contractType.includes('Force Account/')) ?
                            <div>
                                {this.props.contract.divisionName === 'Public Buildings' ?
                                    <div>
                                        {this.props.contract.contractType.includes('/JOCS/') ?
                                            <div>
                                                <div className="col l4 m3 s6">
                                                    <FieldLike label="Projected Construction Start" value={getDateValue(cmDetail[0].prjctdCnstrctnStrtDt)} />
                                                </div>
                                                <div className="col l4 m3 s6">
                                                    <FieldLike label="Actual Construction Start" value={getDateValue(cmDetail[0].actCnstrctnStrtDt)} />
                                                </div>
                                                <div className="col l4 m3 s6">
                                                    <FieldLike label="Substantial Inspection" value={getDateValue(cmDetail[0].substntlInspcDt)} />
                                                </div>
                                                <div className="col l4 m3 s6">
                                                    <FieldLike label="Projected Substantial Completion" value={getDateValue(cmDetail[0].prjctdSubstntlInspcDt)} />
                                                </div>
                                                <div className="col l4 m3 s6">
                                                    <FieldLike label="Actual Substantial Completion" value={getDateValue(cmDetail[0].actSubstntlCmpltnDt)} />
                                                </div>
                                                <div className="col l4 m3 s6">
                                                    <FieldLike label="Punch List" value={cmDetail[0].punchLst ? 'Yes' : 'No'} />
                                                </div>
                                                <div className="col l4 m3 s6">
                                                    <FieldLike label="Guarantee Start" value={getDateValue(cmDetail[0].grntStrtDt)} />
                                                </div>
                                                <div className="col l4 m3 s6">
                                                    <FieldLike label="Guarantee End" value={getDateValue(cmDetail[0].grntEndDt)} />
                                                </div>
                                                <div className="col l4 m3 s6">
                                                    <FieldLike label="Final Inspection" value={getDateValue(cmDetail[0].finalInspctnDt)} />
                                                </div>
                                                <div className="col l4 m3 s6">
                                                    <FieldLike label="Final Completion" value={getDateValue(cmDetail[0].finalCompltnDt)} />
                                                </div>
                                                <div className="col l4 m3 s6">
                                                    <FieldLike label="Contract Close Out" value={getDateValue(cmDetail[0].cntrctClsoutDt)} />
                                                </div>
                                            </div>
                                            :
                                            <div className="col l4 m3 s6">
                                                <FieldLike label="Contract Close Out" value={getDateValue(cmDetail[0].cntrctClsoutDt)} />
                                            </div>
                                        }
                                    </div> :
                                    <div>
                                        {this.props.contract.contractType.includes('/JOCS/') ?
                                            <div>
                                                <div className="col l4 m3 s6">
                                                    <FieldLike label="Substantial Inspection" value={getDateValue(cmDetail[0].substntlInspcDt)} />
                                                </div>
                                                <div className="col l4 m3 s6">
                                                    <FieldLike label="Contract Close Out" value={getDateValue(cmDetail[0].cntrctClsoutDt)} />
                                                </div>
                                            </div> :
                                            <div className="col l4 m3 s6">
                                                <FieldLike label="Contract Close Out" value={getDateValue(cmDetail[0].cntrctClsoutDt)} />
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                            : null}
                    </div>
                    :
                    <div className="row static-modal-fields">
                        {this.props.contract.contractType.includes('Force Account/') && this.props.contract.divisionName === 'Infrastructure' ?
                            <div className="col l4 m3 s6">
                                <FieldLike label="Contract Close Out" value={getDateValue(this.state.cmDetail.cntrctClsoutDt)} />
                            </div>
                            : null}

                        {this.props.contract.contractType.includes('Construction/') ?
                            <div>
                                {this.props.contract.divisionName === 'Infrastructure' ?
                                    <div>
                                        <div className="col l4 m3 s6">
                                            <FieldLike label="Substantial Inspection" value={getDateValue(this.state.cmDetail.substntlInspcDt)} />
                                        </div>
                                        <div className="col l4 m3 s6">
                                            <FieldLike label="Actual Substantial Completion" value={getDateValue(this.state.cmDetail.actSubstntlCmpltnDt)} />
                                        </div>
                                        <div className="col l4 m3 s6">
                                            <FieldLike label="Final Completion" value={getDateValue(this.state.cmDetail.finalCompltnDt)} />
                                        </div>
                                        <div className="col l4 m3 s6">
                                            <FieldLike label="Contract Close Out" value={getDateValue(this.state.cmDetail.cntrctClsoutDt)} />
                                        </div>
                                    </div>
                                    :
                                    <div>
                                        <div className="col l4 m3 s6">
                                            <FieldLike label="Projected Construction Start" value={getDateValue(this.state.cmDetail.prjctdCnstrctnStrtDt)} />
                                        </div>
                                        <div className="col l4 m3 s6">
                                            <FieldLike label="Actual Construction Start" value={getDateValue(this.state.cmDetail.actCnstrctnStrtDt)} />
                                        </div>
                                        <div className="col l4 m3 s6">
                                            <FieldLike label="Substantial Inspection" value={getDateValue(this.state.cmDetail.substntlInspcDt)} />
                                        </div>
                                        <div className="col l4 m3 s6">
                                            <FieldLike label="Projected Substantial Completion" value={getDateValue(this.state.cmDetail.prjctdSubstntlInspcDt)} />
                                        </div>
                                        <div className="col l4 m3 s6">
                                            <FieldLike label="Actual Substantial Completion" value={getDateValue(this.state.cmDetail.actSubstntlCmpltnDt)} />
                                        </div>
                                        <div className="col l4 m3 s6">
                                            <FieldLike label="Punch List" value={''} />
                                        </div>
                                        <div className="col l4 m3 s6">
                                            <FieldLike label="Guarantee Start" value={getDateValue(this.state.cmDetail.grntStrtDt)} />
                                        </div>
                                        <div className="col l4 m3 s6">
                                            <FieldLike label="Guarantee End" value={getDateValue(this.state.cmDetail.grntEndDt)} />
                                        </div>
                                        <div className="col l4 m3 s6">
                                            <FieldLike label="Final Inspection" value={getDateValue(this.state.cmDetail.finalInspctnDt)} />
                                        </div>
                                        <div className="col l4 m3 s6">
                                            <FieldLike label="Final Completion" value={getDateValue(this.state.cmDetail.finalCompltnDt)} />
                                        </div>
                                        <div className="col l4 m3 s6">
                                            <FieldLike label="Contract Close Out" value={getDateValue(this.state.cmDetail.cntrctClsoutDt)} />
                                        </div>
                                    </div>
                                }
                            </div>
                            : null}

                        {(!this.props.contract.contractType.includes('Construction/') && !this.props.contract.contractType.includes('Force Account/')) ?
                            <div>
                                {this.props.contract.divisionName === 'Public Buildings' ?
                                    <div>
                                        {this.props.contract.contractType.includes('/JOCS/') ?
                                            <div>
                                                <div className="col l4 m3 s6">
                                                    <FieldLike label="Projected Construction Start" value={getDateValue(this.state.cmDetail.prjctdCnstrctnStrtDt)} />
                                                </div>
                                                <div className="col l4 m3 s6">
                                                    <FieldLike label="Actual Construction Start" value={getDateValue(this.state.cmDetail.actCnstrctnStrtDt)} />
                                                </div>
                                                <div className="col l4 m3 s6">
                                                    <FieldLike label="Substantial Inspection" value={getDateValue(this.state.cmDetail.substntlInspcDt)} />
                                                </div>
                                                <div className="col l4 m3 s6">
                                                    <FieldLike label="Projected Substantial Completion" value={getDateValue(this.state.cmDetail.prjctdSubstntlInspcDt)} />
                                                </div>
                                                <div className="col l4 m3 s6">
                                                    <FieldLike label="Actual Substantial Completion" value={getDateValue(this.state.cmDetail.actSubstntlCmpltnDt)} />
                                                </div>
                                                <div className="col l4 m3 s6">
                                                    <FieldLike label="Punch List" value={''} />
                                                </div>
                                                <div className="col l4 m3 s6">
                                                    <FieldLike label="Guarantee Start" value={getDateValue(this.state.cmDetail.grntStrtDt)} />
                                                </div>
                                                <div className="col l4 m3 s6">
                                                    <FieldLike label="Guarantee End" value={getDateValue(this.state.cmDetail.grntEndDt)} />
                                                </div>
                                                <div className="col l4 m3 s6">
                                                    <FieldLike label="Final Inspection" value={getDateValue(this.state.cmDetail.finalInspctnDt)} />
                                                </div>
                                                <div className="col l4 m3 s6">
                                                    <FieldLike label="Final Completion" value={getDateValue(this.state.cmDetail.finalCompltnDt)} />
                                                </div>
                                                <div className="col l4 m3 s6">
                                                    <FieldLike label="Contract Close Out" value={getDateValue(this.state.cmDetail.cntrctClsoutDt)} />
                                                </div>
                                            </div>
                                            :
                                            <div className="col l4 m3 s6">
                                                <FieldLike label="Contract Close Out" value={getDateValue(this.state.cmDetail.cntrctClsoutDt)} />
                                            </div>
                                        }
                                    </div>
                                    :

                                    <div>
                                        {this.props.contract.contractType.includes('/JOCS/') ?
                                            <div>
                                                <div className="col l4 m3 s6">
                                                    <FieldLike label="Substantial Inspection" value={getDateValue(this.state.cmDetail.substntlInspcDt)} />
                                                </div>
                                                <div className="col l4 m3 s6">
                                                    <FieldLike label="Contract Close Out" value={getDateValue(this.state.cmDetail.cntrctClsoutDt)} />
                                                </div>

                                            </div> :
                                            <div className="col l4 m3 s6">
                                                <FieldLike label="Contract Close Out" value={getDateValue(this.state.cmDetail.cntrctClsoutDt)} />
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                            : null}
                    </div>

                }
            </div>
        );
    }
}

ReadOnlyContractManagementDetails.propTypes = {
    cmDetail: PropTypes.array.isRequired
};

function mapStateToProps(state, ownProps) {
    return {
        cmDetail: state.additionalProjectsStore.cmDetail,
        projectId: ownProps.projectId
    };
}

export default connect(mapStateToProps, { fetchContractManagementDetails })(ReadOnlyContractManagementDetails);